const EditIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 33 32"
      {...props}
    >
      <path
        d="M25.0048 11.2657L15.6423 20.6283C15.3631 20.9075 15.0075 21.0979 14.6203 21.1753L10.5001 21.9993L11.3241 17.8791C11.4016 17.4919 11.5919 17.1363 11.8711 16.8571L21.2336 7.49444M25.0048 11.2657L27.1261 9.14436C27.5167 8.75383 27.5167 8.12067 27.1261 7.73015L24.7691 5.37312C24.3786 4.9826 23.7454 4.9826 23.3549 5.37312L21.2336 7.49444M25.0048 11.2657L21.2336 7.49444"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.1665 26.666H25.8332"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default EditIcon;
